import type { SVGProps } from 'react';
const SvgFilterSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={17} height={19} fill="none" {...props}>
    <path
      fill="currentColor"
      d="M10.179 9.16v8.02a.98.98 0 0 1-.296.844 1.014 1.014 0 0 1-1.435 0l-2.045-2.046a1 1 0 0 1-.295-.844V9.16h-.031L.215 1.649A1.02 1.02 0 0 1 .388.224 1.06 1.06 0 0 1 1.018 0h14.25c.223 0 .437.081.63.224a1.02 1.02 0 0 1 .173 1.425l-5.862 7.51z"
    />
  </svg>
);
export default SvgFilterSmall;
